module.exports = __webpack_public_path__ + "img/butler.b7e09e62.png";